import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import TabbedContent from '../../../../components/TabbedContent';

import AccountantsMapGraphic from './assets/accountants-map.inline.svg';
import LayersMapGraphic from './assets/lawyers-map.inline.svg';
import BarristersMapGraphic from './assets/barristers-map.inline.svg';
import BuiltEnvMapGraphic from './assets/built-environment-map.inline.svg';

import './style.scss';

const ProgramFindingsSection = () => {
  const tabs = [
    {
      title: 'Accountants',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <AccountantsMapGraphic alt="Average number of persons in accounting sector by state and territory subject to professional standards schemes"/>
          </div>
          <div className="text">
            <p>The accounting profession reported a number of improvements throughout the year including:</p>
            <ul>
              <li>sourcing of professional indemnity insurance data and expert insurance data and information</li>
              <li>
                conducting risk analysis with linkage to controls and evidence-supported strategies. New or emerging
                risks were identified, rated, and controlled
              </li>
              <li>
                one association undertook an external risk review and implemented the risk management recommendations
              </li>
            </ul>

            <p className="sr-only">WA: 4,353</p>
            <p className="sr-only">NT: 214</p>
            <p className="sr-only">SA: 2,766</p>
            <p className="sr-only">QLD: 7,214</p>
            <p className="sr-only">NSW: 15,661</p>
            <p className="sr-only">ACT: 861</p>
            <p className="sr-only">VIC: 12,009</p>
            <p className="sr-only">TAS: 532</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Lawyers',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <LayersMapGraphic alt="Average number of solicitors by state and territory subject to professional standards schemes"/>
          </div>
          <div className="text">
            <p>There were improvements in several areas by solicitors including:</p>
            <ul>
              <li>alignment with the AS ISO 19600:2015 compliance management system requirements</li>
              <li>
                undertaking auditing activities to monitor compliance with the scheme participant’s obligation to
                disclose their limited liability to consumers
              </li>
              <li>
                one association conducted root cause analysis on claims and complaints data, including an assessment of
                the actions that could have been taken to prevent the issue. The analysis was used to implement
                continuing professional development sessions targeting problem areas
              </li>
            </ul>

            <p className="sr-only">WA: 1,934</p>
            <p className="sr-only">NT: 0</p>
            <p className="sr-only">SA: 1,600</p>
            <p className="sr-only">QLD: 6,387</p>
            <p className="sr-only">NSW: 16,138</p>
            <p className="sr-only">ACT: 0</p>
            <p className="sr-only">VIC: 5.187</p>
            <p className="sr-only">TAS: 0</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Barristers',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <BarristersMapGraphic alt="Average number of barristers by state and territory subject to professional standards schemes"/>
          </div>
          <div className="text">
            <p>Noticeable improvements were observed across several bar associations including:</p>
            <ul>
              <li>
                undertaking auditing activities to monitor compliance with the scheme participant’s obligation to
                disclose their limited liability to consumers
              </li>
              <li>one association conducted their first annual continuing professional development audit</li>
              <li>
                two associations responded to risks of sexual harassment by providing specialised training for complaint
                handlers
              </li>
            </ul>

            <p className="sr-only">WA: 261</p>
            <p className="sr-only">NT: 0</p>
            <p className="sr-only">SA: 211</p>
            <p className="sr-only">QLD: 988</p>
            <p className="sr-only">NSW: 2,232</p>
            <p className="sr-only">ACT: 0</p>
            <p className="sr-only">VIC: 1,346</p>
            <p className="sr-only">TAS: 0</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Built Environment',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <BuiltEnvMapGraphic alt="Average number of persons in built environment sector by state and territory subject to professional standards schemes"/>
          </div>
          <div className="text">
            <p>Some of the highest performing areas for the built environment sector included:</p>
            <ul>
              <li>
                informing and educating scheme participants of their compliance obligations under the professional
                standards legislation and scheme
              </li>
              <li>
                compliance with the Annual Membership Assurance Report verifying the number of scheme participants for
                the annual fee period
              </li>
              <li>
                one association provided in-depth analysis of their comprehensive professional indemnity insurance
                claims data. The association used the insights to inform risk management strategies
              </li>
            </ul>

            <p className="sr-only">WA: 345</p>
            <p className="sr-only">NT: 28</p>
            <p className="sr-only">SA: 230</p>
            <p className="sr-only">QLD: 785</p>
            <p className="sr-only">NSW: 1,462</p>
            <p className="sr-only">ACT: 172</p>
            <p className="sr-only">VIC: 1,066</p>
            <p className="sr-only">TAS: 67</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Common Topics',
      content: (
        <div className="program-findings-tab-content">
          <div className="text">
            <p>Common areas of achievement</p>
            <ul>
              <li>Requirements to disclose the scheme by member participants</li>
              <li>Professional indemnity insurance standards</li>
              <li>Compliance planning</li>
            </ul>
          </div>
          <div className="text">
            <p>Common areas for improvement</p>
            <ul>
              <li>Discretionary caps and exemptions</li>
              <li>Complaints and discipline systems improvements and root cause analysis</li>
              <li>Scheme monitoring improvements</li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  return (
    <section className="l-program-findings-section">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
      </Parallax>

      <div className="container">
        <h2 className="section-title">Professional Standard Improvement Program Findings</h2>
        <TabbedContent tabs={tabs} />
      </div>
    </section>
  );
};

export default ProgramFindingsSection;
